import { FormTemplateOption } from 'data/template/template.types';
import { CspConfig } from 'data/cspConfig/cspConfig.types';
import getCspOptions from './getCspOptions';

export const CSP_ADMIN_PRIVILEGE = 'csp_admin';
export const SYSTEM_ADMIN_PRIVILEGE = 'system_admin';

type TeamWithMembers = {
  cspid?: string | null,
  members?: (string | number)[],
};

/**
 * A CSP administrator who is not a system administrator cannot choose a team's CSP.
 */
export function isCspOnlyAdmin(privileges: string[] = []): boolean {
  return privileges.includes(CSP_ADMIN_PRIVILEGE) && !privileges.includes(SYSTEM_ADMIN_PRIVILEGE);
}

/**
 * The user's CSP is the CSP of the first team the user is a member of that has one.
 */
export function getUserCspId(teams: TeamWithMembers[] = [], userDBId?: string | number | null): string {
  if (userDBId === undefined || userDBId === null || userDBId === '') return '';
  const userTeam = teams.find(({ cspid, members = [] }) => (
    !!cspid && members.some((member) => String(member) === String(userDBId))
  ));
  return userTeam?.cspid ?? '';
}

/**
 * Same rule as getUserCspId, for the user's own team list (already limited to the user's teams).
 */
export function getCspIdFromUserTeams(userTeams: { cspid?: string | null }[] = []): string {
  return userTeams.find(({ cspid }) => !!cspid)?.cspid ?? '';
}

/**
 * The only CSP option a CSP-only admin can have: the user's own CSP, or 'None' if the user has no CSP.
 */
export function getUserCspOptions(cspConfigs: CspConfig[] = [], userCspId: string): FormTemplateOption[] {
  const options = getCspOptions(cspConfigs, userCspId);
  if (!userCspId) return options.filter(({ value }) => value === '');
  return options.filter(({ value }) => value === userCspId);
}
